import apolloClient from '../../../apolloClient'
import { workshopsMUT } from '../../../constants/vuexMutations'
import {
  workshopsACT as acts,
  motivateMonitorWorkshopACT as actsMonMot
} from '../../../constants/vuexActions'

import {TYPE_WORKSHOPS_QUERY} from '../../../constants/graphql'

const actions = {
  [acts.REQUEST_MOTIVATE_INFO] ({state, dispatch}) {
    dispatch(`motivateMonitor/${actsMonMot.requestTargetStats}`)
  },
  [acts.REQUEST_WORKSHOPS] ({state, commit}) {
    apolloClient.query({
      query: TYPE_WORKSHOPS_QUERY,
      fetchPolicy: 'network-only'
    }).then(res => {
      commit(workshopsMUT.SET_WORKSHOPS, res.data.allTypeWorkshops.nodes)
    })
  }
}
export default actions



// WEBPACK FOOTER //
// ./src/vuex/modules/workshops/actions.js